<template>
  <div class="page">
    <div class="activity">
      <div class="activity-top">
        <div class="activityTitle">{{ props.data.titleCn }}</div>
        <div class="activityEn">{{ props.data.titleEn }}</div>
      </div>
      <div class="activity-bottom">
        <img class="show-img" :src="props.data.imgUrl" alt="" />
        <div class="section" v-if="props.data.list?.length > 2">
          <el-carousel ref="carouselRef" :autoplay="true" :interval="3000" trigger="click" indicator-position="outside" :motion-blur="false" type="card" height="225px">
              <el-carousel-item v-for="item in props.data.list" :key="item" @click="clickItem(item)">
                  <img class="section-img" :src="item.imgUrl" alt="">
              </el-carousel-item>
          </el-carousel>
        </div>
        <div class="section-list" v-if="props.data.list?.length <= 2">
          <div class="section-item" v-for="item in props.data.list" :key="item.id" @click="clickItem(item)">
            <img :src="item.imgUrl" alt="">
          </div>
        </div>
        <img v-if="props.data.list?.length > 2" src="https://p5.ssl.qhimg.com/t110b9a93012473f0cf01d7cad2.png" alt="" class="bg-img" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue'

const props = defineProps({
  data: {
    type: Object,
    default: {}
  }
})

const clickItem = (item) => {
  window.open(item.linkUrl, '_blank')
}

</script>

<style lang="scss" scoped>
.page{
  width: 100%;
  display: flex;
  justify-content: center;
  .activity {
    width: 1400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 116px;
    .activity-top{
      display: flex;
      flex-direction: column;
      align-items: center;
      .activityTitle{
        color: rgb(44, 44, 44);
        font-family: Source Han Sans;
        font-size: 36px;
        font-weight: 700;
        line-height: 36px;
        letter-spacing: 0px;
        text-transform: uppercase;
      }
      .activityEn{
        color: rgb(44, 44, 44);
        font-family: Rubik;
        font-size: 18px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0px;
        text-transform: uppercase;
        margin-top: 16px;
      }
    }
    .activity-bottom{
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .show-img{
        width: 100%;
        margin-top: 60px;
        margin-bottom: 80px;
      }
      .section{
        width: 90%;
        z-index: 1;
        .section-img{
          width: 100%;
          height: 100%;
        }
      }
      .section-list{
        display: flex;
        justify-content: center;
        gap: 20px;
        .section-item{
          width: 364px;
          cursor: pointer;
          border-radius: 6px;
         img{
          width: 100%;
          height: 130px;
          border-radius: 6px;
         }
       }
      }
      .bg-img{
        width: 100%;
        margin-top: -52px;
      }
    }
  }
  :deep(.el-carousel__arrow) {
      color: #ffffff; /* 更改箭头图标颜色 */
      background-color: #676769; /* 可选，修改背景色 */
      border: none;
      top: calc(50% - 15px);
  }
  :deep(.el-carousel__arrow--left) {
    font-size: 18px;
    left: 20px;
  }

  :deep(.el-carousel__arrow--right) {
    font-size: 18px;
    right: 20px;
  }
  :deep(.el-carousel__indicators--outside button) {
    background-color: #525966;
    opacity: 0.3;
}
  :deep(.el-carousel__indicator.is-active button) {
    background-color: #000000;
    opacity: 1;
  }
  .el-carousel__item:nth-child(2n) {
        background-color: #fff;
        border-radius: 16px;  
    }

    .el-carousel__item:nth-child(2n + 1) {
        background-color: #fff;
        border-radius: 16px;
    }
    .el-carousel__item--card {
        opacity: 0.3;
    }
    .el-carousel__item--card.is-active {
        opacity: 1;
    }
}
</style>
